/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { QuoteTestExpectationMetadata } from "./QuoteTestExpectationMetadata";
import {
  QuoteTestExpectationMetadataFromJSON,
  QuoteTestExpectationMetadataFromJSONTyped,
  QuoteTestExpectationMetadataToJSON,
  QuoteTestExpectationMetadataToJSONTyped,
} from "./QuoteTestExpectationMetadata";
import type { QuoteTestExpectationType } from "./QuoteTestExpectationType";
import {
  QuoteTestExpectationTypeFromJSON,
  QuoteTestExpectationTypeFromJSONTyped,
  QuoteTestExpectationTypeToJSON,
  QuoteTestExpectationTypeToJSONTyped,
} from "./QuoteTestExpectationType";

/**
 *
 * @export
 * @interface PostQuoteTestExpectationBody
 */
export interface PostQuoteTestExpectationBody {
  /**
   *
   * @type {QuoteTestExpectationType}
   * @memberof PostQuoteTestExpectationBody
   */
  type: QuoteTestExpectationType;
  /**
   *
   * @type {string}
   * @memberof PostQuoteTestExpectationBody
   */
  description: string;
  /**
   *
   * @type {QuoteTestExpectationMetadata}
   * @memberof PostQuoteTestExpectationBody
   */
  metadata?: QuoteTestExpectationMetadata | null;
}

/**
 * Check if a given object implements the PostQuoteTestExpectationBody interface.
 */
export function instanceOfPostQuoteTestExpectationBody(
  value: object,
): value is PostQuoteTestExpectationBody {
  if (!("type" in value) || value["type"] === undefined) return false;
  if (!("description" in value) || value["description"] === undefined)
    return false;
  return true;
}

export function PostQuoteTestExpectationBodyFromJSON(
  json: any,
): PostQuoteTestExpectationBody {
  return PostQuoteTestExpectationBodyFromJSONTyped(json, false);
}

export function PostQuoteTestExpectationBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PostQuoteTestExpectationBody {
  if (json == null) {
    return json;
  }
  return {
    type: QuoteTestExpectationTypeFromJSON(json["type"]),
    description: json["description"],
    metadata:
      json["metadata"] == null
        ? undefined
        : QuoteTestExpectationMetadataFromJSON(json["metadata"]),
  };
}

export function PostQuoteTestExpectationBodyToJSON(
  json: any,
): PostQuoteTestExpectationBody {
  return PostQuoteTestExpectationBodyToJSONTyped(json, false);
}

export function PostQuoteTestExpectationBodyToJSONTyped(
  value?: PostQuoteTestExpectationBody | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    type: QuoteTestExpectationTypeToJSON(value["type"]),
    description: value["description"],
    metadata: QuoteTestExpectationMetadataToJSON(value["metadata"]),
  };
}
